import type { APPLICATION_DOCUMENTS } from './index'

export enum LOAN_APPLICATION_FILE_PROCESSING_STATUS {
  PENDING = 'PENDING',
  READING = 'READING',
  VALIDATING = 'VALIDATING',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
}

export interface FileValidationResult {
  fileId: number
  label: APPLICATION_DOCUMENTS
  valid: boolean
  errorCode: FILE_VALIDATION_ERROR_CODE | null
  severity: FILE_VALIDATION_SEVERITY | null
  validationMessage: string | null
}

export enum FILE_VALIDATION_ERROR_CODE {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  PAYSLIP_DATA_UNAVAILABLE = 'PAYSLIP_DATA_UNAVAILABLE',
  PAYSLIP_NOT_RECENT = 'PAYSLIP_NOT_RECENT',
  PAYSLIP_NOT_CONSECUTIVE = 'PAYSLIP_NOT_CONSECUTIVE',
  PAYSLIP_DUPLICATE = 'PAYSLIP_DUPLICATE',
}

export enum FILE_VALIDATION_SEVERITY {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  FAILED = 'FAILED',
}
